import { Picture } from 'components/picture/Picture'
import { Step, StepsGuideList } from 'components/stepsGuide/StepsGuide'
import { Title, TTitleVariant } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { numberRange } from 'utils/general'

const stepVisuals = {
  image_1: 'illustrations/device',
  image_2: 'illustrations/testament',
  image_3: 'illustrations/safe',
} as const

export const FutureMessageSteps = (props: {
  title?: string
  className?: string
  titleVariant?: TTitleVariant
}) => {
  const { t } = useTranslation('future_message')

  const steps: Step[] = numberRange(3).map((i) => ({
    title: t(`future_message.future_message_steps.step_${i}.title`),
    desc: t(`future_message.future_message_steps.step_${i}.description`),
    visual: <Picture imageKey={stepVisuals[`image_${i}`]} sizes={'350px'} />,
  }))

  return (
    <div className={props.className}>
      {props.title && (
        <div css={{ marginBottom: '2rem' }}>
          <Title variant={props.titleVariant || ['h4', 'h4', 'h3']} as="h3">
            {props.title}
          </Title>
        </div>
      )}

      <StepsGuideList steps={steps} />
    </div>
  )
}
